<template>
  <div class="warehouse-dimension">
    <!-- 仓库总览列表和细项列表搜索 -->
    <div class="search">
      <el-form ref="searchForm" :model="searchForm">
        <div class="row">
          <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
            <el-select
              class="white"
              clearable
              v-model="searchForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：" prop="date" class="customer-form">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn-form">
            <el-button icon="el-icon-search" class="btn-blue" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </el-form-item>
        </div>
        <el-button v-if="notVerifiedProjectList.length" type="text" class="btn-text" @click="openNotVerifiedProject">未核实项目</el-button>
      </el-form>
    </div>

    <!-- 仓库总览列表 -->
    <div class="table">
      <div class="title">
        <span>仓库总览</span>
        <span class="total-nums">{{ tableData.length - 1 }}</span>
      </div>
      
      <el-table ref="table" :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName" 
       @sort-change="sortChange" :row-class-name="rowClassName">
        <el-table-column label="科目明细" prop="name" show-overflow-tooltip>
          <template slot-scope="scope">
            <a
              :href="`#${scope.row.name}`"
              :class="[
                (scope.row.name === '合计（含税）'|| scope.row.name === '合计（税后）') ? 'high-total' : 
                (scope.row.name === '保底差额' || scope.row.name === '空仓成本' || scope.row.name === '预估销项税金' || scope.row.name === '预估进项税金') ? 'high-total-two'
                : 'high-name',
              ]"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
          :sortable="item.prop === 'income'?'custom':false"
        >
          <template slot-scope="scope">
            <div
              :style="`
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: ${item.alignment};
              `"
              :class="[
                (scope.row.name === '合计（含税）' || scope.row.name === '合计（税后）' ) ? 'high-total' :
                (scope.row.name === '保底差额' || scope.row.name === '空仓成本' || scope.row.name === '预估销项税金' || scope.row.name === '预估进项税金') ? 'high-total-two':
                'default-name',
                item.prop === 'grossProfit' && scope.row['grossProfit'] < 0
                  ? 'high-red'
                  : '',
                item.alignment === 'right'?`right-align-width`:'',
              ]"
            >
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 细项列表 -->
    <div
      class="table details-table"
      v-for="(item, index) in detailsTableList"
      :key="index"
    >
      <div class="title" :id="item.title">{{ item.title }}</div>
      <el-table ref="table" :data="item.tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
        <el-table-column
          v-for="(item, index) in detailsTableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        >
          <template slot-scope="scope">
            <div
              :style="`
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: ${item.alignment};
              `"
              :class="[
                scope.row.name === '合计' ? 'high-total' : 'default-name',
                item.prop === 'grossProfit' && scope.row['grossProfit'] < 0
                  ? 'high-red'
                  : '',
                item.alignment === 'right'?`right-align-width`:'',
              ]"
            >
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 回到顶部 -->
    <div class="back-top" v-if="isShowBackTop" @click="backTop">
      <img src="../../../../../assets/images/backTop.png" />
    </div>

    <!-- 未核实项目 -->
    <el-drawer
      title="未核实项目"
      class="not-verified-drawer"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="drawer-content">
        <el-collapse accordion>
          <el-collapse-item
            v-for="(item, index) in notVerifiedProjectList"
            :key="index"
          >
            <template slot="title">
              <img class="arrow-right" src="../../../../../assets/images/arrow/arrow-right.png">
              <span>{{ item.createTime }}</span>
              <div class="amount-info">
                <span class="amount-text">（{{ item.projectList.length }}项）</span>
              </div>
            </template>
            <div
              class="project-row"
              v-for="(item, index) in item.projectList"
              :key="index"
            >
              <div class="project-row-name">{{ item.name }}</div>
              <div class="revenue-expenditure">
                <div class="revenue-expenditure-collect">
                  <img class="revenue-expenditure-img" src="../../../../../assets/images/home/collect.png">
                  {{ item.collect }}
                </div>
                <!-- <div class="revenue-expenditure-branch">
                  <img class="revenue-expenditure-img" src="../../../../../assets/images/home/branch.png">
                  {{ item.branch }}
                </div> -->
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DataReport from "models/data-report";
import warehouseMixins from "@/common/mixins/warehouse.js"
import notVerifiedProjectMixins from "@/common/mixins/not-verified-project.js"
import { formatTimeToDate, numsToRMBSymbolAndMillimeter } from "common/js/util";
export default {
  mixins: [warehouseMixins, notVerifiedProjectMixins],
  data() {
    return {
      tableData: [],
      tableTitleList: [
        { label: "收入", prop: "income", width: "", alignment:'right' },
        { label: "支出", prop: "expenditure", width: "", alignment:'right' },
        { label: "毛利", prop: "grossProfit", width: "", alignment:'right' },
      ],
      detailsTableList: [],
      detailsTableTitleList: [
        { label: "项目", prop: "name", width: "", alignment:'left' },
        { label: "收入", prop: "income", width: "", alignment:'right' },
        { label: "支出", prop: "expenditure", width: "", alignment:'right' },
        { label: "毛利", prop: "grossProfit", width: "", alignment:'right' },
      ],
      searchForm: {
        warehouseId: "",
        date: this.timeDefault(),
      },
      selectDate: "",
      //日期选择范围在31天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      isShowBackTop: false,
      drawer: false,
    };
  },

  created() {
    this.initWarehouse();
    this.initList();
    this.initDetailsList();
    this.initNotVerifiedProjectList()
  },
  // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
  mounted () {
    document.getElementById('pageContent').addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    document.getElementById('pageContent').removeEventListener('scroll', this.scrollToTop)
  },

  methods: {
    /**
     * @desc 未核实项目
     */
    initNotVerifiedProjectList() {
      let warehouseId = this.searchForm.warehouseId;
      let startDate = this.searchForm.date[0]
      let endDate = this.searchForm.date[1]
      let data = {
        startDate,
        endDate,
        warehouseId
      }
      this.initNotVerifiedProject(data)
    },

    /**
     * @desc 仓库总览
     */
    initList() {
      let warehouseId = this.searchForm.warehouseId;
      let startDate = this.searchForm.date[0]
      let endDate = this.searchForm.date[1]
      let data = {
        warehouseId,
        startDate,
        endDate
      };
      DataReport.getWarehouseOverviewList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.name = i.name? i.name:'-';
            obj.incomeNums = i.income? i.income: 0
            obj.income = i.income?numsToRMBSymbolAndMillimeter(i.income):'-';
            obj.expenditure = i.cost?numsToRMBSymbolAndMillimeter(i.cost):'-';
            obj.grossProfit = i.grossProfit?numsToRMBSymbolAndMillimeter(i.grossProfit):'-';
            obj.differenceFee = i.differenceFee?numsToRMBSymbolAndMillimeter(i.differenceFee):'-';
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /**
     * @desc 细项列表
     */
    initDetailsList() {
      let warehouseId = this.searchForm.warehouseId;
      let startDate = this.searchForm.date[0]
      let endDate = this.searchForm.date[1]
      let data = {
        warehouseId,
        startDate,
        endDate
      };

      DataReport.getWarehouseDetailsList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.title = i.title;
            obj.tableData = []
            i.list.map(v => {
              let obj2 = {}
              obj2.name = v.name? v.name:'-';
              obj2.income = v.income?numsToRMBSymbolAndMillimeter(v.income):'-';
              obj2.expenditure = v.cost?numsToRMBSymbolAndMillimeter(v.cost):'-';
              obj2.grossProfit = v.grossProfit?numsToRMBSymbolAndMillimeter(v.grossProfit):'-';
              obj.tableData.push(obj2)
            })
            arr.push(obj);
          });
          this.detailsTableList = arr;
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex, column }) {
      if (columnIndex > 0) {
        return 'right-align'
      }
    },

    rowClassName({row}) {
      if (row.name === '合计（含税）' || row.name === '合计（税后）') {
        return 'row-total'
      }
    },

    sortChange(column) {
      let tableData = this.tableData
      let nameArr = ['保底差额', '空仓成本','合计（含税）','预估销项税金','预估进项税金','合计（税后）']
      // 放置合计行数据
      let totalArr = []
      let tableArr = []
      tableData.map(item => {
        if (nameArr.indexOf(item.name) !== -1) {
          totalArr.push(item)
        } else {
          tableArr.push(item)
        }
      })
      if (column.order === 'ascending') {
        // 升序
        tableArr = tableArr.sort((a, b) => a.incomeNums - b.incomeNums)
      } else {
        // 降序
        tableArr = tableArr.sort((a, b) => b.incomeNums - a.incomeNums)
      }
      this.tableData = tableArr.concat(totalArr)
    },
    
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000)
      const firstDate = formatTimeToDate(date.setDate(1))
      let arr = [firstDate, yesterday]
      if (new Date().getDate() === 1)  arr = [firstDate, firstDate]
      return arr;
    },

    search() {
      if (!this.searchForm.date) {
        return this.$message.error('请先选择日期')
      }
      this.currentPage = 1;
      this.initList();
      this.initDetailsList();
      this.initNotVerifiedProjectList()
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * @desc 点击图片回到顶部方法，加计时器是为了过渡顺滑
     */
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.getElementById('pageContent').scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    /**
     * @desc 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
     */
    scrollToTop () {
      const that = this
      let scrollTop = document.getElementById('pageContent').pageYOffset || document.getElementById('pageContent').scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 120) {
        that.isShowBackTop = true
      } else {
        that.isShowBackTop = false
      }
    },
    
    openNotVerifiedProject() {
      this.drawer = true
    },

    handleCloseDrawer() {
      this.drawer = false
    },
  }
};
</script>

<style lang='scss'>
.warehouse-dimension {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    padding: 20px 44px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    height: 72px;
    .el-form {
      width: 100%;
      @include flex-between;
      .el-form-item {
        margin-right: 30px;
      }
      .el-form-item:nth-of-type(2) {
        margin-right: 20px;
      }
      .el-form-item:last-child {
        margin-right: 0px;
      }
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .btn-text {
        margin-bottom: 16px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px !important;
        }
        .el-form-item__content {
          margin-left: 50px !important;
        }
      }
      .btn-form {
        @include flex-start;
        .el-button {
          padding-top: 0px;
          padding-bottom: 0px;
        }
      }
    }
    @media screen and (max-width: 900px) {
      .el-form {
        .el-form-item .el-form-item__label {
          line-height: 40px;
        }
        .el-input__inner {
          line-height: 27px;
        }
        .el-date-editor .el-range-input {
          line-height: 21px;
        }
        .el-input__suffix {
          top: 0px;
        }
        .btn-form {
          margin-bottom: 24px;
        } 
      }
    }
    @media screen and (max-width: 600px) {
      .el-form {
        .el-form-item .el-form-item__label {
          line-height: 41px;
        }
        .el-input__inner {
          line-height: 27px;
        }
        .el-input__suffix {
          top: 0px;
        }
        .el-date-editor .el-range-input {
          height: 28px;
          line-height: 27px;
        }
        .el-date-editor .el-input__icon {
          height: 24px;
          line-height: 24px;
        }
        .btn-form {
          margin-bottom: 22px;
        } 
      }
    }
  }

  .table {
    padding: 0px 54px 20px 54px;
    .title {
      border-left: 3px solid $baseBlue;
      padding-left: 7px;
      font-size: 14px;
      font-weight: 400;
      color: $baseGrey;
      margin-bottom: 12px;
      @include flex-start;
      .total-nums {
        display: inline-block;
        color: white;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        font-weight: 800;
        padding: 0px 3px;
        margin-left: 4px;
        border-radius: 2px;
        background: $baseBlue;
        box-sizing: border-box;
        font-family: 'PingFang SC-Heavy, PingFang SC';
      }
      @media screen and (max-width: 900px) {
        .total-nums {
          padding: 1px 0px 0px 3px;
          min-width: 14px;
          text-align: center;
        }
      }
      @media screen and (max-width: 600px) {
        .total-nums {
          padding: 1px 0px 0px 3px;
          min-width: 14px;
          text-align: center;
        }
      }
    }
    .high-name {
      display: inline-block;
      width: 100%;
      color: $baseBlue;
      font-size: 14px;
      cursor: pointer;
    }
    .high-total {
      font-weight: 500;
      font-family: 'PingFang SC-Medium';
      color: $baseGrey;
      font-size: 14px;
    }
    .high-total-two {
      font-weight: 500;
      font-family: 'PingFang SC-Regular';
      color: $baseGrey;
      font-size: 14px;
    }
    .default-name {
      color: $baseTwoGrey;
    }
    .right-align-width {
      width: 140px;
    }
    .right-align-width-income {
      width: 220px;
    }
  }
  .table .el-table .el-table__header-wrapper .el-table__header tr th.right-align {
    .cell {
      padding-left: 130px;
    }
  }
  .table .el-table .el-table__header-wrapper .el-table__header tr th.right-aling-income {
    .cell {
      padding-left: 210px;
    }
  }
  .table .el-table .el-table__body-wrapper .el-table__body .row-total {
    background-color: $tableRowHignBgColor;
  }
  .details-table {
    padding-top: 0px;
  }
  .back-top {
    width: 79px;
    height: 79px;
    position: fixed;
    bottom: 100px;
    right: 50px;
    z-index: 10;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .not-verified-drawer {
    .el-drawer {
      width: 480px!important;
    }
    .el-drawer__header {
      margin-bottom: 0px;
    }
    .el-drawer__body {
      height: calc(100% - 56px);
      @include flex-column-between;
      overflow-y: auto;
      @include scrollbarNotrack(4px);
      .el-collapse {
        border: 0px;
        padding: 0px;
        &-item {
          border-bottom: 1px solid $baseThreeSnow;
          &__header {
            font-size: 14px;
            font-family: 'PingFang SC-Regular, PingFang SC';
            font-weight: 400;
            color: $baseGrey;
            border: 0px;
            .arrow-right {
              width: 16px;
              height: 16px;
              margin-right: 4px;
              transition: all 0.4s;
            }
            .amount-info {
              color: $baseThreeGrey;
              .amount-text {
                margin-right: 30px;
              }
            }
            .el-collapse-item__arrow {
              display: none;
            }
          }
          &__header.is-active {
            .arrow-right {
              transform: rotate(90deg);
              transition: all 0.4s;
            }
          }
          &__wrap {
            border: 0px;
          }
          &__content {
            padding-bottom: 16px;
            .project-row {
              @include flex-start;
              height: 32px;
              padding: 0px 10px;
              background: $baseSixSnow;
              margin-bottom: 16px;
              &-name {
                width: 116px;
                font-size: 14px;
                font-family: 'PingFang SC-Regular, PingFang SC';
                font-weight: 400;
                color: $baseGrey;
                @include two-wrap-ellipsis(1);
              }
              .revenue-expenditure {
                flex: 1;
                @include flex-around;
                font-size: 14px;
                font-family: 'PingFang SC-Regular, PingFang SC';
                font-weight: 400;
                color: $baseGrey;
                &-img {
                  width: 14px;
                  height: 14px;
                  margin-bottom: 2px;
                }
              }
            }
            .project-row:last-child {
              margin-bottom: 0px;
            }
          }
        }
      }
    }
  }
}
</style>
